import { render, staticRenderFns } from "./TraffictViolationDetail.vue?vue&type=template&id=72efe85f&scoped=true"
import script from "./TraffictViolationDetail.vue?vue&type=script&lang=js"
export * from "./TraffictViolationDetail.vue?vue&type=script&lang=js"
import style0 from "./TraffictViolationDetail.vue?vue&type=style&index=0&id=72efe85f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72efe85f",
  null
  
)

export default component.exports